export class BaseSelect {
  guid: string;
  label: string;

  constructor(data: { guid: string; label: string }) {
    this.guid = data.guid;
    this.label = data.label;
  }
}
